import {useOktaAuth} from "@okta/okta-react";
import {useAuthState} from "../../providers/AuthProvider";
import {StyledLink} from "./StyledLink";
import {usePreferenceContext} from "../../providers/PreferenceProvider";
import {navigateToCmsOrder} from "../../services/CmsService";

export type TJobLinkItem = {
  jobNumber: string;
  jobId: number;
  orderId: number;
};

export const JobLinksRenderer = (items: TJobLinkItem[]) => {
  const {tenant} = useAuthState();
  const {oktaAuth} = useOktaAuth();
  const {tenantPreferences} = usePreferenceContext();

  const handleGoToCmsOrder = async (orderID: number | undefined) => {
    await navigateToCmsOrder(tenant!, oktaAuth.getAccessToken() ?? "", orderID, tenantPreferences);
  };
  return (
    <>
      {items.map((item, index) => (
        <span key={item.jobId}>
          <StyledLink data-testid={`order-link-of-${item.jobId}`} onClick={() => void handleGoToCmsOrder(item.orderId)}>
            {item.jobNumber}
          </StyledLink>
          {index < items.length - 1 ? ", " : ""}
        </span>
      ))}
    </>
  );
};
